export const ImgCompnent = ({ url }: any) => (
      <>
        <a
            href={url}
            rel="noreferrer"
            target="_blank"
        ><img src={url} /></a>
      </>
)

export default ImgCompnent;
